import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faUserSecret,faAdd,faPen,faSearch,faShoppingCart,faTrash, faComment, faComments } from '@fortawesome/free-solid-svg-icons'
import { faCopyright } from '@fortawesome/free-regular-svg-icons'

import VueGoodTablePlugin from 'vue-good-table-next';
import vfmPlugin from 'vue-final-modal'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import BootstrapVue from 'bootstrap-vue-3'
import {BToastPlugin} from 'bootstrap-vue-3'
import Vue3MobileDetection from "vue3-mobile-detection";

// import the styles
import 'vue-good-table-next/dist/vue-good-table-next.css'
/* add icons to the library */
library.add(...[faUserSecret,faPen,faSearch,faCopyright,faShoppingCart,faTrash,faComments])
library.add(faAdd)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import "./assets/bootstrap.min.css" 

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const app = createApp(App);

app.use(store);
app.use(router); 
app.use(VueGoodTablePlugin); 
app.use(vfmPlugin); 
app.use(BootstrapVue);
app.use(BToastPlugin);
app.use(VueSweetalert2);
app.use(Vue3MobileDetection);
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('Datepicker', Datepicker);
app.mount('#app')
